import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-57c7181d")

_pushScopeId("data-v-57c7181d")
const _hoisted_1 = { class: "mb-2 flex items-end space-x-2" }
const _hoisted_2 = { class: "text-3xl" }
const _hoisted_3 = { class: "bg-secondary flex items-center justify-between px-2 py-1" }
const _hoisted_4 = { class: "flex space-x-2" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "text-center text-2xl mb-6" }, "Editar Ruma", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "pt-8" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "pt-2"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "text-center text-2xl mb-1" }, "Editar Guías Asociadas", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "text-center text-xs text-gray-400 mb-4" }, "Solo administrador · edita las guías VIGENTES de la ruma", -1)
const _hoisted_10 = { class: "rounded-md bg-yellow-50 border-l-4 border-yellow-500 text-yellow-800 text-sm px-4 py-3 mb-4" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" ⚠️ Esto modificará ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" guías ")
const _hoisted_13 = /*#__PURE__*/_createVNode("strong", null, "activas", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" de la ruma. La operación ")
const _hoisted_15 = /*#__PURE__*/_createVNode("strong", null, "no se puede revertir", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_17 = {
  key: 0,
  class: "rounded-md bg-gray-50 border border-gray-200 px-4 py-3 mb-5 text-sm"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("p", { class: "text-xs uppercase tracking-wide text-gray-400 mb-2" }, "Valores actuales de la ruma (cálculo sobre las guías)", -1)
const _hoisted_19 = { class: "grid grid-cols-2 gap-x-4 gap-y-1" }
const _hoisted_20 = { class: "col-span-2" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "text-gray-400" }, "Estado:", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "text-gray-400" }, "Especie (ruma):", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "text-gray-400" }, "Especie (guías):", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "text-gray-400" }, "Mes corta (prom.):", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "text-gray-400" }, "Año plant. (prom.):", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "text-gray-400" }, "Producto:", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "text-gray-400" }, "Zona:", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "text-gray-400" }, "Procedencia:", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { class: "text-xs uppercase tracking-wide text-gray-400 mb-2" }, "Nuevos valores — deja vacío para conservar · especie y producto se cambian juntos", -1)
const _hoisted_30 = { class: "grid grid-cols-2 gap-x-4 gap-y-1 items-start" }
const _hoisted_31 = { class: "input-container" }
const _hoisted_32 = { class: "input-container" }
const _hoisted_33 = { class: "input-container" }
const _hoisted_34 = { class: "input-container" }
const _hoisted_35 = { class: "input-container" }
const _hoisted_36 = { class: "grid grid-cols-2 gap-x-4 gap-y-1 items-start mt-1" }
const _hoisted_37 = { class: "input-container" }
const _hoisted_38 = { class: "input-container" }
const _hoisted_39 = /*#__PURE__*/_createVNode("p", { class: "text-xs uppercase tracking-wide text-gray-400 mt-3 mb-1" }, "Derivados del producto (no editables — se aplican a las guías)", -1)
const _hoisted_40 = { class: "grid grid-cols-2 gap-x-4 items-start" }
const _hoisted_41 = { class: "input-container" }
const _hoisted_42 = { class: "input-container" }
const _hoisted_43 = { class: "pt-6" }
const _hoisted_44 = {
  key: 1,
  class: "rounded-md bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-800"
}
const _hoisted_45 = { class: "mb-3" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Se modificarán ")
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" guías activas sin posibilidad de revertir. ¿Confirmas?")
const _hoisted_48 = { class: "text-xl mb-4" }
const _hoisted_49 = /*#__PURE__*/_createVNode("strong", null, "Ruma", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("strong", null, "Cancha", -1)
const _hoisted_51 = {
  key: 0,
  class: "flex align-center justify-center my-10 text-gray-300 font-light"
}
const _hoisted_52 = { key: 1 }
const _hoisted_53 = /*#__PURE__*/_createVNode("span", null, "VOLVER", -1)
const _hoisted_54 = {
  key: 3,
  style: {"max-width":"100%","overflow-x":"scroll","padding-bottom":"12px"}
}
const _hoisted_55 = { class: "ruma-guides" }
const _hoisted_56 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("th", null, "Fecha"),
  /*#__PURE__*/_createVNode("th", null, "Zona"),
  /*#__PURE__*/_createVNode("th", null, "Procedencia"),
  /*#__PURE__*/_createVNode("th", null, "Guía"),
  /*#__PURE__*/_createVNode("th", null, "Movimiento"),
  /*#__PURE__*/_createVNode("th", null, "Producto"),
  /*#__PURE__*/_createVNode("th", null, "Origen"),
  /*#__PURE__*/_createVNode("th", null, "Destino"),
  /*#__PURE__*/_createVNode("th", null, "Vol.MR Original"),
  /*#__PURE__*/_createVNode("th", null, "Vol.MR"),
  /*#__PURE__*/_createVNode("th", null, "Vol.M3Ssc")
], -1)
const _hoisted_57 = {
  key: 0,
  class: "bg-gray-200 py-4"
}
const _hoisted_58 = /*#__PURE__*/_createVNode("td", { colspan: "8" }, null, -1)
const _hoisted_59 = {
  key: 4,
  class: "flex align-center justify-center my-10 text-gray-300 font-light"
}
const _hoisted_60 = {
  key: 5,
  class: "mt-4"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("p", { class: "my-4" }, "Ajustes", -1)
const _hoisted_62 = { style: {"max-width":"100%","overflow-x":"scroll","padding-bottom":"12px"} }
const _hoisted_63 = { class: "ruma-guides" }
const _hoisted_64 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("th", null, "Tipo Ajuste"),
  /*#__PURE__*/_createVNode("th", null, "Zona"),
  /*#__PURE__*/_createVNode("th", null, "Procedencia"),
  /*#__PURE__*/_createVNode("th", null, "Producto"),
  /*#__PURE__*/_createVNode("th", null, "Origen"),
  /*#__PURE__*/_createVNode("th", null, "Destino"),
  /*#__PURE__*/_createVNode("th", null, "Vol.MR Original"),
  /*#__PURE__*/_createVNode("th", null, "Vol.MR"),
  /*#__PURE__*/_createVNode("th", null, "Vol.M3Ssc")
], -1)
const _hoisted_65 = {
  key: 0,
  class: "bg-gray-200 py-4"
}
const _hoisted_66 = /*#__PURE__*/_createVNode("td", { colspan: "6" }, null, -1)
const _hoisted_67 = { style: {"max-width":"100%","overflow-x":"scroll","padding-bottom":"12px"} }
const _hoisted_68 = { class: "ruma-guides mt-10" }
const _hoisted_69 = /*#__PURE__*/_createVNode("td", null, "TOTALES", -1)
const _hoisted_70 = { class: "bg-gray-100 my-3 p-2" }
const _hoisted_71 = /*#__PURE__*/_createVNode("div", { class: "pt-4" }, null, -1)
const _hoisted_72 = {
  key: 0,
  class: "text-center my-10"
}
const _hoisted_73 = { class: "mb-2" }
const _hoisted_74 = {
  key: 0,
  class: "pop-data"
}
const _hoisted_75 = { class: "drawer-text-item" }
const _hoisted_76 = /*#__PURE__*/_createVNode("strong", null, "Ruma", -1)
const _hoisted_77 = { class: "drawer-text-item" }
const _hoisted_78 = /*#__PURE__*/_createVNode("strong", null, "Cancha", -1)
const _hoisted_79 = { class: "drawer-text-item" }
const _hoisted_80 = /*#__PURE__*/_createVNode("strong", null, "Especie", -1)
const _hoisted_81 = { class: "drawer-text-item" }
const _hoisted_82 = /*#__PURE__*/_createVNode("strong", null, "Condición", -1)
const _hoisted_83 = { class: "drawer-text-item" }
const _hoisted_84 = /*#__PURE__*/_createVNode("strong", null, "Estado", -1)
const _hoisted_85 = { class: "drawer-text-item" }
const _hoisted_86 = /*#__PURE__*/_createVNode("strong", null, "Producto", -1)
const _hoisted_87 = { class: "drawer-text-item" }
const _hoisted_88 = /*#__PURE__*/_createVNode("strong", null, "Mes Cort", -1)
const _hoisted_89 = { class: "drawer-text-item" }
const _hoisted_90 = /*#__PURE__*/_createVNode("strong", null, "Año Plantación", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ruma_filter = _resolveComponent("ruma-filter")
  const _component_ui_simple_input = _resolveComponent("ui-simple-input")
  const _component_excel_req = _resolveComponent("excel-req")
  const _component_ui_table = _resolveComponent("ui-table")
  const _component_ui_table_nav = _resolveComponent("ui-table-nav")
  const _component_ui_text_input = _resolveComponent("ui-text-input")
  const _component_ui_text_select = _resolveComponent("ui-text-select")
  const _component_ui_button = _resolveComponent("ui-button")
  const _component_ui_modal = _resolveComponent("ui-modal")
  const _component_fa_icon = _resolveComponent("fa-icon")
  const _component_GMapInfoWindow = _resolveComponent("GMapInfoWindow")
  const _component_GMapMarker = _resolveComponent("GMapMarker")
  const _component_GMapMap = _resolveComponent("GMapMap")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("p", _hoisted_2, _toDisplayString(_ctx.routeName), 1),
      (_ctx.userStoreState && _ctx.userStoreState.role !== 'CONSULTOR' && _ctx.userStoreState.role !== 'SUPERVISOR')
        ? (_openBlock(), _createBlock("p", {
            key: 0,
            class: "cursor-pointer border-r-2 border-black border-solid pr-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'rumas.create' })))
          }, "Crear Ruma"))
        : _createCommentVNode("", true),
      (_ctx.userStoreState.role === 'ADMINISTRADOR' || _ctx.userStoreState.role === 'RECEPTOR')
        ? (_openBlock(), _createBlock("p", {
            key: 1,
            class: "cursor-pointer",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showFullMapFn && _ctx.showFullMapFn(...args)))
          }, "Ver Mapa"))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ruma_filter, {
      onFilter: _ctx.onFilterRequest,
      onUnfilter: _ctx.unfilter
    }, null, 8, ["onFilter", "onUnfilter"]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_ui_simple_input, {
          label: "Buscar Ruma",
          ref: "singleRumaSearchRef",
          onInput: _cache[3] || (_cache[3] = (evt) => (_ctx.filter.ruma = evt)),
          filterFn: _ctx.searchSingleRuma
        }, null, 8, ["filterFn"])
      ]),
      _createVNode(_component_excel_req, { cb: _ctx.requestReport }, null, 8, ["cb"])
    ]),
    _createVNode(_component_ui_table, {
      ref: "mainTable",
      geo: _ctx.userStoreState.role === 'ADMINISTRADOR' || _ctx.userStoreState.role === 'RECEPTOR',
      headers: _ctx.headers,
      clickable: true,
      actions: _ctx.userStoreState && _ctx.userStoreState.role !== 'CONSULTOR' && _ctx.userStoreState.role !== 'SUPERVISOR' ? _ctx.actions : [],
      items: _ctx.items,
      "pre-image-fn": _ctx.clearRumaImage,
      onFile: _ctx.handleRumaFile,
      onMap: _ctx.selectedMap,
      key: _ctx.tableKey
    }, null, 8, ["geo", "headers", "actions", "items", "pre-image-fn", "onFile", "onMap"]),
    _createVNode(_component_ui_table_nav, {
      initial: _ctx.itemsCount.initial,
      actual: _ctx.itemsCount.actual,
      total: _ctx.itemsCount.total,
      onCount: _ctx.onPagedRequest,
      onNext: _ctx.onPageRequest,
      onPrevious: _ctx.onPageRequest,
      perPage: _ctx.filter.qty,
      loading: _ctx.isLoading
    }, null, 8, ["initial", "actual", "total", "onCount", "onNext", "onPrevious", "perPage", "loading"]),
    _createVNode(_component_ui_modal, {
      modalState: _ctx.modalState,
      "onUpdate:modalState": _cache[9] || (_cache[9] = ($event: any) => (_ctx.modalState = $event))
    }, {
      default: _withId(() => [
        _hoisted_5,
        _createVNode(_component_ui_text_input, {
          placeholder: "Número Ruma",
          value: _ctx.ruma.numero,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.ruma.numero = $event)),
          valueModifiers: { number: true },
          disabled: true
        }, null, 8, ["value"]),
        _createVNode(_component_ui_text_select, {
          label: "Especie",
          ref: "editRumaEspecieRef",
          default: _ctx.especieDefault,
          items: _ctx.especies,
          onSelected: _cache[5] || (_cache[5] = (evt) => (_ctx.ruma.especie = evt))
        }, null, 8, ["default", "items"]),
        _createVNode(_component_ui_text_select, {
          label: "Estado Madera",
          ref: "editRumaEstadoMaderaRef",
          default: _ctx.estadoMaderaDefault,
          items: _ctx.estadoMadera,
          onSelected: _cache[6] || (_cache[6] = (evt) => (_ctx.ruma.estadoMadera = evt))
        }, null, 8, ["default", "items"]),
        _createVNode(_component_ui_text_select, {
          label: "Condición Ruma",
          items: _ctx.estadoRuma,
          ref: "editRumaEstadoRumaRef",
          default: _ctx.estadoRumaDefault,
          onSelected: _cache[7] || (_cache[7] = (evt) => (_ctx.ruma.estadoRuma = evt))
        }, null, 8, ["items", "default"]),
        _hoisted_6,
        _createVNode(_component_ui_button, {
          label: "Guardar Cambios",
          onClick: _ctx.updateRuma,
          loading: _ctx.isUpdating
        }, null, 8, ["onClick", "loading"]),
        (_ctx.userStoreState.role === 'ADMINISTRADOR')
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode(_component_ui_button, {
                label: "Editar Guías Asociadas",
                onClick: _ctx.openBulkEdit
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("p", {
          class: "text-center text-green-800 py-2 select-none cursor-pointer hover:bg-gray-50 rounded-md transition-all duration-300",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.modalState = false))
        }, "Cancelar")
      ]),
      _: 1
    }, 8, ["modalState"]),
    _createVNode(_component_ui_modal, {
      modalState: _ctx.modalStateBulkEdit,
      "onUpdate:modalState": _cache[19] || (_cache[19] = ($event: any) => (_ctx.modalStateBulkEdit = $event)),
      width: "760px"
    }, {
      default: _withId(() => [
        _hoisted_8,
        _hoisted_9,
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode("strong", null, _toDisplayString(_ctx.bulkCount), 1),
          _hoisted_12,
          _hoisted_13,
          _hoisted_14,
          _hoisted_15,
          _hoisted_16
        ]),
        (_ctx.currentRumaRow)
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              _hoisted_18,
              _createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createTextVNode(" " + _toDisplayString(_ctx.currentRumaRow.estadoRuma), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_22,
                  _createTextVNode(" " + _toDisplayString(_ctx.currentRumaRow.especie), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_23,
                  _createTextVNode(" " + _toDisplayString(_ctx.bulkEspeciesGuiasLabel || '—'), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_24,
                  _createTextVNode(" " + _toDisplayString(_ctx.currentRumaRow.mesCorta), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_25,
                  _createTextVNode(" " + _toDisplayString(_ctx.currentRumaRow.anioPlantacion), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_26,
                  _createTextVNode(" " + _toDisplayString(_ctx.currentRumaRow.producto), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_27,
                  _createTextVNode(" " + _toDisplayString(_ctx.currentRumaRow.zona), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_28,
                  _createTextVNode(" " + _toDisplayString(_ctx.currentRumaRow.procedencia), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_29,
        _createVNode("div", _hoisted_30, [
          _createVNode("div", _hoisted_31, [
            _createVNode(_component_ui_text_select, {
              label: "Intervención",
              items: _ctx.intervenciones,
              onSelected: _cache[10] || (_cache[10] = (evt) => (_ctx.bulkForm.intervencion = evt))
            }, null, 8, ["items"])
          ]),
          _createVNode("div", _hoisted_32, [
            _createVNode(_component_ui_text_select, {
              label: "Zona",
              items: _ctx.zonas,
              onSelected: _cache[11] || (_cache[11] = (evt) => (_ctx.bulkForm.zona = evt))
            }, null, 8, ["items"])
          ]),
          _createVNode("div", _hoisted_33, [
            _createVNode(_component_ui_text_select, {
              label: "Procedencia",
              items: _ctx.procedencias,
              onSelected: _cache[12] || (_cache[12] = (evt) => (_ctx.bulkForm.procedencia = evt))
            }, null, 8, ["items"])
          ]),
          _createVNode("div", _hoisted_34, [
            _createVNode(_component_ui_text_select, {
              label: "Especie",
              items: _ctx.especies,
              onSelected: _ctx.onBulkEspecie,
              onUnselect: _ctx.onUnselectBulkEspecie
            }, null, 8, ["items", "onSelected", "onUnselect"])
          ]),
          _createVNode("div", _hoisted_35, [
            _createVNode(_component_ui_text_select, {
              ref: "bulkProductoRef",
              label: "Producto",
              items: _ctx.bulkProductos,
              onSelected: _ctx.onBulkProducto,
              onUnselect: _ctx.onUnselectBulkProducto
            }, null, 8, ["items", "onSelected", "onUnselect"])
          ])
        ]),
        _createVNode("div", _hoisted_36, [
          _createVNode("div", _hoisted_37, [
            _createVNode(_component_ui_text_input, {
              placeholder: "Fecha corta (DD-MM-YYYY)",
              value: _ctx.bulkForm.fechaCorta,
              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (_ctx.bulkForm.fechaCorta = $event))
            }, null, 8, ["value"])
          ]),
          _createVNode("div", _hoisted_38, [
            _createVNode(_component_ui_text_input, {
              placeholder: "Año plantación",
              value: _ctx.bulkForm.anioPlantacion,
              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (_ctx.bulkForm.anioPlantacion = $event))
            }, null, 8, ["value"])
          ])
        ]),
        _hoisted_39,
        _createVNode("div", _hoisted_40, [
          _createVNode("div", _hoisted_41, [
            _createVNode(_component_ui_text_input, {
              placeholder: "Largo (derivado del producto)",
              disabled: true,
              value: _ctx.bulkDerived.largo,
              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => (_ctx.bulkDerived.largo = $event))
            }, null, 8, ["value"])
          ]),
          _createVNode("div", _hoisted_42, [
            _createVNode(_component_ui_text_input, {
              placeholder: "Código SAP (derivado del producto)",
              disabled: true,
              value: _ctx.bulkDerived.codigoSAP,
              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => (_ctx.bulkDerived.codigoSAP = $event))
            }, null, 8, ["value"])
          ])
        ]),
        _createVNode("div", _hoisted_43, [
          (!_ctx.bulkConfirming)
            ? (_openBlock(), _createBlock(_component_ui_button, {
                key: 0,
                label: "Guardar cambios",
                onClick: _ctx.tryBulkConfirm
              }, null, 8, ["onClick"]))
            : (_openBlock(), _createBlock("div", _hoisted_44, [
                _createVNode("p", _hoisted_45, [
                  _hoisted_46,
                  _createVNode("strong", null, _toDisplayString(_ctx.bulkCount), 1),
                  _hoisted_47
                ]),
                _createVNode(_component_ui_button, {
                  label: "Sí, modificar guías",
                  onClick: _ctx.doBulkEdit,
                  loading: _ctx.isBulkSaving
                }, null, 8, ["onClick", "loading"]),
                _createVNode("p", {
                  class: "text-center text-gray-500 py-2 cursor-pointer",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.bulkConfirming = false))
                }, "Volver")
              ]))
        ]),
        _createVNode("p", {
          class: "text-center text-green-800 py-2 select-none cursor-pointer hover:bg-gray-50 rounded-md transition-all duration-300",
          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.modalStateBulkEdit = false))
        }, "Cancelar")
      ]),
      _: 1
    }, 8, ["modalState"]),
    _createVNode(_component_ui_modal, {
      modalState: _ctx.modalStateGuides,
      "onUpdate:modalState": _cache[21] || (_cache[21] = ($event: any) => (_ctx.modalStateGuides = $event)),
      width: "1200px"
    }, {
      default: _withId(() => [
        _createVNode("p", _hoisted_48, [
          _hoisted_49,
          _createTextVNode(" " + _toDisplayString(_ctx.rumaGuideSelected.ruma) + " - ", 1),
          _hoisted_50,
          _createTextVNode(" " + _toDisplayString(_ctx.rumaGuideSelected.cancha), 1)
        ]),
        (!_ctx.rumaGroups.length)
          ? (_openBlock(), _createBlock("div", _hoisted_51, " No posee guias asociada "))
          : (_ctx.rumaGroups.length && !_ctx.isShowingDetails)
            ? (_openBlock(), _createBlock("section", _hoisted_52, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rumaGroups, (ruma) => {
                  return (_openBlock(), _createBlock("div", {
                    key: `${ruma.zona}-${ruma.procedencia}`,
                    class: "ruma-group",
                    onClick: ($event: any) => (_ctx.setRumaGroupsGuides(ruma.guides, true,{ zona: ruma.zona, procedencia: ruma.procedencia }))
                  }, [
                    _createVNode("span", null, _toDisplayString(ruma.procedencia) + " - " + _toDisplayString(ruma.zonaName), 1),
                    _createVNode(_component_fa_icon, { icon: ['fa', 'chevron-right'] })
                  ], 8, ["onClick"]))
                }), 128))
              ]))
            : (_ctx.rumaGroups.length && _ctx.isShowingDetails)
              ? (_openBlock(), _createBlock("div", {
                  key: 2,
                  class: "guide-back",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setRumaGroupsGuides([], false)))
                }, [
                  _createVNode(_component_fa_icon, { icon: ['fa', 'chevron-left'] }),
                  _hoisted_53
                ]))
              : _createCommentVNode("", true),
        (_ctx.rumaGuidesDetails.length && _ctx.isShowingDetails)
          ? (_openBlock(), _createBlock("div", _hoisted_54, [
              _createVNode("table", _hoisted_55, [
                _hoisted_56,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rumaGuidesDetails, (guide) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: guide.id
                  }, [
                    _createVNode("td", null, _toDisplayString(guide.fechaGuia), 1),
                    _createVNode("td", null, _toDisplayString(_ctx.getZonaById(guide.zona)), 1),
                    _createVNode("td", null, _toDisplayString(guide.procedencia), 1),
                    _createVNode("td", null, _toDisplayString(guide.guiaArauco), 1),
                    _createVNode("td", null, _toDisplayString(guide.movimiento), 1),
                    _createVNode("td", null, _toDisplayString(guide.producto), 1),
                    _createVNode("td", null, _toDisplayString(guide.origen), 1),
                    _createVNode("td", null, _toDisplayString(guide.destino), 1),
                    _createVNode("td", null, _toDisplayString(guide.originalMR), 1),
                    _createVNode("td", null, _toDisplayString(guide.volumenMR), 1),
                    _createVNode("td", null, _toDisplayString(guide.volumenMSSC), 1)
                  ]))
                }), 128)),
                (_ctx.rumaGuidesDetails.length)
                  ? (_openBlock(), _createBlock("tr", _hoisted_57, [
                      _hoisted_58,
                      _createVNode("td", null, _toDisplayString(_ctx.rumaGroupTotals.volMROriginal), 1),
                      _createVNode("td", null, _toDisplayString(_ctx.rumaGroupTotals.volMR), 1),
                      _createVNode("td", null, _toDisplayString(_ctx.rumaGroupTotals.volM3), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (!_ctx.rumaGuidesDetails.length && _ctx.isShowingDetails)
            ? (_openBlock(), _createBlock("div", _hoisted_59, " No posee guias asociada "))
            : _createCommentVNode("", true),
        (_ctx.isShowingDetails && _ctx.rumaAjustedFilteres.length)
          ? (_openBlock(), _createBlock("div", _hoisted_60, [
              _hoisted_61,
              _createVNode("div", _hoisted_62, [
                _createVNode("table", _hoisted_63, [
                  _hoisted_64,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rumaAjustedFilteres, (ajuste) => {
                    return (_openBlock(), _createBlock("tr", {
                      key: ajuste.id
                    }, [
                      _createVNode("td", null, _toDisplayString(ajuste.tipoAjusteText), 1),
                      _createVNode("td", null, _toDisplayString(ajuste.zona), 1),
                      _createVNode("td", null, _toDisplayString(ajuste.procedencia), 1),
                      _createVNode("td", null, _toDisplayString(ajuste.producto), 1),
                      _createVNode("td", null, _toDisplayString(ajuste.origen), 1),
                      _createVNode("td", null, _toDisplayString(ajuste.destino), 1),
                      _createVNode("td", null, _toDisplayString(ajuste.valorAjuste), 1),
                      _createVNode("td", null, _toDisplayString(ajuste.valorAjusteMR), 1),
                      _createVNode("td", null, _toDisplayString(ajuste.valorAjusteM3), 1)
                    ]))
                  }), 128)),
                  (_ctx.rumaAjustedFilteres.length)
                    ? (_openBlock(), _createBlock("tr", _hoisted_65, [
                        _hoisted_66,
                        _createVNode("td", null, _toDisplayString(_ctx.ajusteGroupTotals.volMROriginal), 1),
                        _createVNode("td", null, _toDisplayString(_ctx.ajusteGroupTotals.volMR), 1),
                        _createVNode("td", null, _toDisplayString(_ctx.ajusteGroupTotals.volM3), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_67, [
                _createVNode("table", _hoisted_68, [
                  _hoisted_69,
                  _createVNode("td", null, "Original: " + _toDisplayString(_ctx.rumaGroupTotals.volMROriginal + _ctx.ajusteGroupTotals.volMROriginal), 1),
                  _createVNode("td", null, "MR: " + _toDisplayString(_ctx.rumaGroupTotals.volMR + _ctx.ajusteGroupTotals.volMR), 1),
                  _createVNode("td", null, "M3: " + _toDisplayString(_ctx.rumaGroupTotals.volM3 + _ctx.ajusteGroupTotals.volM3), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modalState"]),
    _createVNode(_component_ui_modal, {
      modalState: _ctx.mapModalState,
      "onUpdate:modalState": _cache[26] || (_cache[26] = ($event: any) => (_ctx.mapModalState = $event)),
      width: "800px"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_70, [
          _createVNode("span", null, _toDisplayString(_ctx.selectedMapData.n), 1),
          _createVNode("span", null, _toDisplayString(_ctx.selectedMapData.cancha), 1)
        ]),
        (_ctx.selectedMapData.img)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "modal-img bg-gray-50 mb-3 relative",
              style: { backgroundImage: `url(${_ctx.rumaImageUrl(_ctx.selectedMapData.id)})`}
            }, [
              _createVNode("div", {
                class: "reset-geo-data bg-red-700 text-white",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.resetGeoData(_ctx.selectedMapData.id)))
              }, "RESET GEO DATA"),
              _createVNode("div", {
                class: "new-image-upload bg-primary text-white",
                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.updateImage && _ctx.updateImage(...args)))
              }, "ACTUALIZAR IMAGEN")
            ], 4))
          : _createCommentVNode("", true),
        _createVNode(_component_GMapMap, {
          center: _ctx.selectedMapData.geo,
          zoom: 18,
          "map-type-id": "satellite",
          style: {"width":"100%","height":"400px"}
        }, {
          default: _withId(() => [
            _createVNode(_component_GMapMarker, {
              position: _ctx.selectedMapData.geo,
              label: _ctx.selectedMapData.n,
              clickable: true,
              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.openMarker(_ctx.selectedMapData.id)))
            }, {
              default: _withId(() => [
                _createVNode(_component_GMapInfoWindow, {
                  closeclick: true,
                  onCloseclick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.openMarker(null))),
                  opened: _ctx.mapMarker === _ctx.selectedMapData.id
                }, {
                  default: _withId(() => [
                    _createVNode("div", null, _toDisplayString(_ctx.selectedMapData.n) + " - " + _toDisplayString(_ctx.selectedMapData.cancha), 1)
                  ]),
                  _: 1
                }, 8, ["opened"])
              ]),
              _: 1
            }, 8, ["position", "label"])
          ]),
          _: 1
        }, 8, ["center"])
      ]),
      _: 1
    }, 8, ["modalState"]),
    _createVNode(_component_ui_modal, {
      modalState: _ctx.showFullMap,
      "onUpdate:modalState": _cache[30] || (_cache[30] = ($event: any) => (_ctx.showFullMap = $event)),
      width: "800px"
    }, {
      default: _withId(() => [
        _hoisted_71,
        (!_ctx.mapRumas.length)
          ? (_openBlock(), _createBlock("p", _hoisted_72, "No hay ubicaciones definidas"))
          : (_openBlock(), _createBlock(_component_GMapMap, {
              key: 1,
              center: _ctx.mapRumas.length ? _ctx.mapRumas[0].geo : { lat: 0, lng: 0 },
              zoom: 16,
              "map-type-id": "satellite",
              style: {"width":"100%","height":"600px"}
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mapRumas, (ruma) => {
                  return (_openBlock(), _createBlock(_component_GMapMarker, {
                    key: ruma.id,
                    position: ruma.geo,
                    label: ruma.n,
                    clickable: true,
                    onClick: ($event: any) => (_ctx.openMarker(ruma.id))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_GMapInfoWindow, {
                        closeclick: true,
                        onCloseclick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.openMarker(null))),
                        opened: _ctx.mapMarker === ruma.id
                      }, {
                        default: _withId(() => [
                          false
                            ? (_openBlock(), _createBlock("div", {
                                key: 0,
                                class: "ruma-pop-image",
                                style: { backgroundImage: `url(${_ctx.rumaImageUrl(ruma.id)})`}
                              }, null, 4))
                            : _createCommentVNode("", true),
                          _createVNode("div", _hoisted_73, _toDisplayString(ruma.n) + " - " + _toDisplayString(ruma.cancha), 1),
                          _createVNode("div", {
                            class: "pop-item-btn mb-2",
                            onClick: ($event: any) => (_ctx.showDetailedMap(ruma))
                          }, "Ver Detalle", 8, ["onClick"]),
                          _createVNode("div", {
                            class: "pop-item-btn",
                            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.openMarker(null)))
                          }, "Cerrar")
                        ]),
                        _: 2
                      }, 1032, ["opened"]),
                      (_ctx.showMapDrawer && _ctx.mapMarker)
                        ? (_openBlock(), _createBlock("div", _hoisted_74, [
                            _createVNode("div", {
                              class: "map-drawer-close",
                              onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.showMapDrawer = false))
                            }, [
                              _createVNode(_component_fa_icon, { icon: ['fas', 'chevron-left'] })
                            ]),
                            _createVNode("div", {
                              class: "pop-drawer-img",
                              style: { backgroundImage: `url(${_ctx.rumaImageUrl(_ctx.mapDrawerRuma.data._id)})`}
                            }, null, 4),
                            _createVNode("p", _hoisted_75, [
                              _hoisted_76,
                              _createTextVNode(" " + _toDisplayString(_ctx.mapDrawerRuma.data.numero), 1)
                            ]),
                            _createVNode("p", _hoisted_77, [
                              _hoisted_78,
                              _createTextVNode(" " + _toDisplayString(_ctx.mapDrawerRuma.data.cancha.codigo) + " " + _toDisplayString(_ctx.mapDrawerRuma.data.cancha.descripcion), 1)
                            ]),
                            _createVNode("p", _hoisted_79, [
                              _hoisted_80,
                              _createTextVNode(" " + _toDisplayString(_ctx.mapDrawerRuma.data.especie.descripcion), 1)
                            ]),
                            _createVNode("p", _hoisted_81, [
                              _hoisted_82,
                              _createTextVNode(" " + _toDisplayString(_ctx.mapDrawerRuma.data.estadoMadera.descripcion), 1)
                            ]),
                            _createVNode("p", _hoisted_83, [
                              _hoisted_84,
                              _createTextVNode(" " + _toDisplayString(_ctx.mapDrawerRuma.data.estadoRuma.descripcion), 1)
                            ]),
                            _createVNode("p", _hoisted_85, [
                              _hoisted_86,
                              _createTextVNode(" " + _toDisplayString(_ctx.mapDrawerRuma.data.producto.join(', ')), 1)
                            ]),
                            _createVNode("p", _hoisted_87, [
                              _hoisted_88,
                              _createTextVNode("a " + _toDisplayString(_ctx.mapDrawerRuma.data.mesCorta), 1)
                            ]),
                            _createVNode("p", _hoisted_89, [
                              _hoisted_90,
                              _createTextVNode(" " + _toDisplayString(_ctx.mapDrawerRuma.data.anioPlantacion), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["position", "label", "onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["center"]))
      ]),
      _: 1
    }, 8, ["modalState"])
  ], 64))
})